import { useState, useEffect } from 'react';
import { Files } from 'helpers/FileHelpers';
import { MediaList } from 'models/BaseModel';


export const useLogoImage = (fileList: any, setFileList: React.Dispatch<React.SetStateAction<any>>, setLogoUrl: React.Dispatch<React.SetStateAction<string | null>>, setError: (error: string | null) => void) => {
  const [logoImage, setLogoImage] = useState<File | null>(null);
  

  useEffect(() => {
    if (fileList?.logo) {
      Files.ImageAPI.Load('logo', fileList, Files.ImageAPI.Fetch, setLogoUrl);
    }
  }, [fileList, setLogoUrl]);

  const handleLogoImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setLogoImage(event.target.files[0]);
    }
  };

  const handleAttachLogoImage = async () => {
    if (logoImage) {
      const uploadedFile = await Files.ImageAPI.Attach(logoImage, 200, setError);
      setFileList((prevFileList: MediaList) => ({
        ...prevFileList,
        logo: uploadedFile,
      }));
    }
  };

  const handleDeleteLogoImage = () => {
    Files.ImageAPI.Delete(fileList?.logo, setFileList, setLogoUrl);
  };

  return {
    logoImage,
    handleLogoImageChange,
    handleAttachLogoImage,
    handleDeleteLogoImage,
  };
};
